import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import Button from '~/components/Shared/Buttons/Button';
import { ArticleContext } from '~/contexts/ArticleContext';
import { getHasSlideshow } from '~/utilities/getHasSlideshow';
import { updatePageUrl } from '~/utilities/updatePageUrl';
import { GA } from '~/utilities/GA';
import { getCurrentPathname } from '~/utilities/getCurrentPathname';
import type { ArticleInterface } from '~/types/AppData/PageContent/ArticleInterface';

export default component$((): JSX.Element => {
  const { payloadToSSR, appState, env } = useContext(AppDataContext);
  const article = useContext(ArticleContext);

  if (!article) return <></>;

  const slideshow = payloadToSSR.pageContent.slideshow ?? article.slideshow;

  if (!getHasSlideshow(article as ArticleInterface, slideshow)) return <></>;

  const nextDisabled =
    appState.currentSlide >= Object.keys(slideshow?.slidesLinks ?? {}).length;

  return (
    <div class='mb-5 flex justify-center'>
      <Button
        id='next-button-bottom'
        testId='next-button-bottom'
        ariaLabel='Next Slide'
        variant={nextDisabled ? 'disabled' : 'primary'}
        size='lg'
        onClick$={() => {
          if (nextDisabled) return;

          window.document.querySelector('#slideshow-controls')?.scrollIntoView({
            behavior: 'smooth', // Optional for smooth scrolling
          });

          appState.currentSlide++;
          updatePageUrl(
            getCurrentPathname(payloadToSSR),
            appState.currentSlide,
            env
          );

          const GoogleAnalytics = new GA(
            article as ArticleInterface,
            payloadToSSR,
            {
              currentSlide: appState.currentSlide,
            }
          );

          GoogleAnalytics.pushPageViewEvent({
            event: 'GTM data ready to GA - Slideshow',
            eventLabel: 'Slideshow page view',
            eventAction: 'Slideshow Pageview',
            isSlideshow: true,
            finiteScrollIndex: 0,
            moreProperties: {
              slideNumber: appState.currentSlide,
              slideControlsClick: 'next',
            },
          });
        }}
      >
        {slideshow?.nextText.value}
      </Button>
    </div>
  );
});
